
import { Model } from 'backbone';

export default class Review extends Model.extend({}) {}
